import { type ReactNode } from 'react';
import { Drawer } from '@monorepo/nova-ui';
import { type OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset } from '../credit-events.types';
import CreditAssetSelectorMobile from './credit-asset-selector-mobile';

interface RedeemCreditsTooltipMobileProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  cartAssets?: CreditCartAsset[];
  onApply?: (asset: OptionalAssets) => void;
  onNewOrder: () => void;
}

const RedeemCreditsTooltipMobile = ({
  open,
  onClose,
  children,
  cartAssets,
  onApply,
  onNewOrder,
}: RedeemCreditsTooltipMobileProps) => (
  <>
    {children}
    <Drawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
      slotProps={{
        paper: {
          sx: {
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            overflow: 'hidden',
          },
        },
      }}
    >
      {cartAssets && onApply && (
        <CreditAssetSelectorMobile
          cartAssets={cartAssets}
          onApply={onApply}
          onNewOrder={onNewOrder}
        />
      )}
    </Drawer>
  </>
);

export default RedeemCreditsTooltipMobile;
